/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Page 1', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
      {title: 'Client',   url: '/Client',      icon: 'ClentIcon', is_bookmarked: false},
      {title: 'Setting', url: '/Setting', icon: 'SettingIcon', is_bookmarked: false},
    ]
  }
}
/* eslint-enable */
